// Configuration de l'URL de l'API
// En production, l'API est servie depuis la meme origine (meme domaine)
// En dev, on utilise localhost:5000

const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  const hostname = window.location.hostname;

  // En local (dev), pointer vers le backend sur le port 5000
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:5000';
  }

  // En production (domaine, IP, tunnel), utiliser la meme origine
  // car le reverse proxy (Caddy/Nginx) route /api vers le backend
  return window.location.origin;
};

export const API_URL = getApiUrl();

export const apiCall = async (endpoint, options = {}) => {
  const url = `${API_URL}${endpoint}`;
  return fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};
